import type { ClientResponse } from 'hono/client';

import { ApiRequestError } from './errors.ts';

interface ErrorBody {
  error?: { code: string; message: string; details?: unknown };
}

/** Unwraps `{ data }` or throws ApiRequestError from `{ error: { code, message, details } }`. */
export async function unwrap<T>(
  res: Promise<ClientResponse<{ data: T }>> | ClientResponse<{ data: T }>,
): Promise<T> {
  const response = await res;
  if (response.ok) return ((await response.json()) as { data: T }).data;
  let body: ErrorBody = {};
  try {
    body = (await response.json()) as ErrorBody;
  } catch {
    /* non-JSON */
  }
  throw new ApiRequestError(
    response.status,
    body.error?.code ?? 'http_error',
    body.error?.message ?? response.statusText,
    body.error?.details,
  );
}
